import { render } from "./OttoPremiumCard.vue?vue&type=template&id=28685000&scoped=true"
import script from "./OttoPremiumCard.vue?vue&type=script&lang=js"
export * from "./OttoPremiumCard.vue?vue&type=script&lang=js"

import "./OttoPremiumCard.vue?vue&type=style&index=0&id=28685000&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28685000"]])

export default __exports__